import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
//import { setfrozenPopUp } from "../../app/actions/Notifications";
import Cropper from "react-cropper";
import AxiosWithAuth from "../../app/auth/jwtMiddleware";
import { showAlert } from "../showAlerts";
import { getLanguageFromLocalStorage } from "../../app/utilities/localization";
import { getProfileData } from "../../app/actions/Profile";
import ImageCropper from "../ImageCropper";
import "./success.scss";


const url = process.env.REACT_APP_PUBLIC_URL;


export default function IdVerificationPopup({ profileData: propProfileData }) {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // id_veristatus
 
  const [icCompletePopUp, setShowPopup] = useState(false);
  

  const [loading, setLoading] = useState(false);
  const [isBrowser, setIsBrowser] = useState(true);

  const language = getLanguageFromLocalStorage() || 'en';

  useEffect(() => {
      console.log('id verification popup ');
      if(propProfileData.id_veristatus==2){
        setShowPopup(true);
      }
    //   const timer = setTimeout(() => {
    //     setShowPopup(false);
    //   }, 180000); // 3 minutes = 180,000 milliseconds
    //   // Cleanup the timer when the component unmounts
    // return () => clearTimeout(timer);
  }, [propProfileData]);

  const toProfile = (e) => {
    e.preventDefault();
   window.location.href = '/profile';

  
  }; 

  const handleCloseCropper = (e) => {
    e.preventDefault();
    console.log('Setting popup close calling');
    document.getElementById('idverify-popup').classList.remove('active');
  };


    function closePopups(e) {
      e.preventDefault();
      setShowPopup(false);
    
    }
  return (
    <>
      {loading && <div className="loader"></div>}
      <div
        id="idverify-popup"
        className={`popup-main report big has-icon  ${icCompletePopUp ? 'active' : ''}`}
        style={{ zIndex: 99999 }}
      >
         {/* <div className='close-area'>
        <button className='close-button-main'
         onClick={(e) => closePopups(e)}
        >X</button>
      </div> */}
        <div className="wrap_new thankyou text-center">
          <span className="subheading mt-30 mb-20">
            <p>
            ❌ Rejected: Unfortunately, your ID proof could not be verified due to [reason, e.g., unclear image, mismatched details]. Please upload a valid ID proof to complete the verification process. 
            </p>
            <p>If you need assistance, feel free to contact our support team.</p>
            
             <p>
            Best regards,<br></br>
            The Mohabbatein Team
           </p>
          </span>


          

          <div id="cropModalFrozen" className="popup-main">
            <div className="wrapper">
              <button className="close test_popu" onClick={handleCloseCropper}></button>

              <div className="cropwrapper">
                {!isBrowser ? (
                  <>
                    {/* You can add browser-specific content here */}
                  </>
                ) : (
                  <>
                    {/* You can add browser-related content here */}
                  </>
                )}
              </div>
            </div>
          </div>

       
            <button onClick={toProfile} className="main-bt mt-30" style={{marginRight:"10px"}} >Go To Profile</button>
     

          <button onClick={closePopups} className="main-bt mt-30">Close</button>
          
        </div>
      </div>
    </>
  );
}

